/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var KeyDown = /** @class */ (function (_super) {
    tslib_1.__extends(KeyDown, _super);
    function KeyDown(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        return _this;
    }
    KeyDown.prototype.componentDidMount = function () {
        window.addEventListener("keydown", this.handleKeyDown, false);
    };
    KeyDown.prototype.componentWillUnmount = function () {
        window.removeEventListener("keydown", this.handleKeyDown, false);
    };
    KeyDown.prototype.handleKeyDown = function (e) {
        var keyCode = e.keyCode;
        var _a = this.props, keyCodes = _a.keyCodes, onKeyDown = _a.onKeyDown;
        if (!keyCodes || keyCodes.indexOf(keyCode) >= 0) {
            return onKeyDown(e);
        }
        return;
    };
    KeyDown.prototype.render = function () {
        var children = this.props.children;
        return React.Children.only(children);
    };
    KeyDown.propTypes = {
        keyCodes: PropTypes.arrayOf(PropTypes.number),
        onKeyDown: PropTypes.func.isRequired
    };
    return KeyDown;
}(React.Component));
exports.KeyDown = KeyDown;